<template>
    <div>
      <img width="100%" src="../assets/video-img.jpg">
        <answer-header type="back"></answer-header>
        <!-- <img class="logo" src="../assets/logo.png"> -->

        <div class="coming-soon ac">
          <div class="viedo">
            <div class="viedo-li" v-for="(item,index) in list" @click="goGame(item)">
                <div class="img-div"><img class="img" :src="item.image_url" /></div>
                <div class="disflex">
                  <div class="">
                    <div class="title">{{item.title}}</div>
                    <div class="disflex">
                      <div class="crb1b3c9">
                        <img class="zan" src="../assets/eyes.png" />{{item.views}}ကြည့်ရှုပြီး
                      </div>
                    </div>
                  </div>
                  <div class="">
                    <img class="play" src="../assets/Play.png" />
                  </div>
                </div>
            </div>

            <div class="more txtcenter">
              <span @click="getMore">ထပ်ကြည့်မယ်</span>>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Menu',
    components: {answerHeader},
    data(){
        return {
          list:[],
          isShow:true,
          page:1,
          page_size:4
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    created(){
      this.getHome()
    },
    methods: {
        _goto(target){
            this.$router.push(target);
        },
        goGame(item){
          this.$router.push({path:'/video',query:{video_id:item.video_id}});
        },
        getHome(item){
          let that = this
          Utils.$ajax({
              url: '/video/list/&page_id='+this.page+'&page_size='+this.page_size
          }).done(res=>{
            console.log(res)
              if(res.code != 0){
                  this.$messagebox_lang(res.msg).then();
                  return;
              }else{
                //this.list = res.data.list
                if(res.data.list.length>0){
                  if(that.page>1){
                    that.list = that.list.concat(res.data.list)
                  }else{
                    that.list = res.data.list
                  }
                }else{
                	that.isShow = false;
                }
              }
          })
        },
        getMore(){
        	let that = this;
        	if(that.isShow){
        		that.page++;
        		that.getHome();
        	}else{
            this.$messagebox_lang('noMore').then(action=>{
            });
        	}
        },
    }
}
</script>

<style lang="scss" scoped>
  .header{left:rem(20) !important}
  .coming-soon{padding:0 rem(25)}
  .disflex{display: flex;justify-content: space-between;}
  .zan{vertical-align: middle;width: rem(26);height: rem(17);margin-right: rem(10);}
  .viedo-li{background: #ebecfb;padding:rem(15);border-radius: rem(20);margin-bottom: 10px;}
  .viedo-li .img{width: 100%;height: auto;}
  .img-div{width:rem(642);height:rem(292);overflow: hidden;border-radius: 10px;margin-bottom: 10px;}
  .img{object-fit: cover;width: 100%;height: 100%;}
  .play{width: rem(77);height: rem(77);}
  .crb1b3c9{color:#b1b3c9}
  .more{padding-bottom: 10px;font-size: 20px;color:#d21938 !important}
    .menu-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-around;
        left: 0;
        top: rem(300);
        bottom: 0;
        width: 100%;
        height: rem(800);
        .menu-item{
            flex: 0 0 50%;
            text-align: center;
            img{
                display: inline-block;
                width: rem(160);
                height: rem(160);
                border-radius: 50%;
            }
        }
    }
</style>










// WEBPACK FOOTER //
// src/components/comingSoon.vue